import React from "react";

export default function AboutIsland() {
  return (
    <>
      <div className="fq-faq-area fq-faq-bdr  pb-100">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <h1 className="text-color-yellow bold-text">
                About Kryptogram Island{" "}
              </h1>
              <div className="fq-faq-wrapper">
                <div className="tp-service-2-accordion-box">
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse9"
                          aria-expanded="true"
                          aria-controls="collapse9"
                        >
                          Where is Kryptogram Island located?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse9"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Kryptogram Island is a privately owned
                            blockchain-powered island in the USA, designed as a
                            real-world community for NFT holders, crypto
                            investors, and blockchain pioneers.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse10"
                          aria-expanded="false"
                          aria-controls="collapse10"
                        >
                          What is Kryptogram Island used for?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse10"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Kryptogram Island will serve as a blockchain
                            innovation hub, featuring:
                          </p>
                          <div class="service-details__fea-list">
                            <ul>
                              <li>
                                NFT-backed real estate for Kryptogram holders.
                              </li>
                              <li>
                                Business & networking centers for blockchain
                                entrepreneurs.
                              </li>
                              <li>
                                Luxury retreatsfor VIP investors and crypto
                                pioneers.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse11"
                          aria-expanded="false"
                          aria-controls="collapse11"
                        >
                          Do I get a legal land title for my Kryptogram Island
                          plot?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse11"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Yes. Once you own 5 NFTs and claim your land, you
                            will receive a blockchain-verified property deed,
                            ensuring secure and transparent ownership.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-items">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-buttons collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse12"
                          aria-expanded="false"
                          aria-controls="collapse12"
                        >
                          Can I sell my Kryptogram Island land in the future?
                          <span className="accordion-icon" />
                        </button>
                      </h2>
                      <div
                        id="collapse12"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Yes, Kryptogram Island landowners will have the
                            ability to sell, lease, or trade their land plots on
                            the secondary market. Future updates will allow
                            tokenized land transactions via smart contracts.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

<div className="tp-about-2-content">
  <span></span>
  <p className="mb-30"></p>
  <span></span>
  <p className="mb-30"></p>
</div>;
